import React, { useEffect, useRef, useState } from "react";
import { AppDispatch } from "../../../../redux/store";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../../../../assets/scss/customer-home.scss";
import { getStates } from "../../../../services/customer/dropdown";
import { getSearchPropertyDetail } from "../../../../redux/actions/customer/searchAction";

import SvgIcon from "../../../../assets/icons/SvgIcon";
import FormikWrapper from "../../../../components/FormikWrapper";
import SearchForm from "./SearchForm";
import { GUJARAT_STATE_ID } from "../../../../clientConfig";
import useDisableScroll from "../../../../hooks/useDisableScrollBar";

interface SearchSectionProps {
  searchBox?: boolean;
  closeSearchBox: () => void;
}

const SearchSection: React.FC<SearchSectionProps> = ({
  searchBox,
  closeSearchBox,
}) => {
  const initialValues = {
    searchQuery: "",
    state: "",
    city: "",
  };

  typeof window !== "undefined" &&
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useDisableScroll(window?.innerWidth <= 1024 ? (searchBox ?? false) : false);

  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const hasStateFetch = useRef(false);

  const [stateList, setStateList] = useState([]);

  const handleStateData = (data: any) => {
    const formattedData = data.map((item: any) => ({
      label: item.name,
      value: item._id,
    }));
    setStateList(formattedData);
  };

  useEffect(() => {
    if (!hasStateFetch.current) {
      getStates(handleStateData);
      hasStateFetch.current = true;
    }
  }, []);

  const handleSearchProperty = (search: any) => {
    const data = {
      searchQuery: search?.searchQuery?.trim(),
      state_id: search?.state?.value ?? GUJARAT_STATE_ID,
      city_id: search?.city?.value,
      page: 1,
      limit: 50,
      startPrice: 0,
      endPrice: 0,
    };

    navigate(
      `search?page=1${search?.searchQuery?.trim() ? `&searchQuery=${search?.searchQuery?.trim()}` : ""}&state_id=${search?.state?.value ?? ""}&city_id=${search?.city?.value ?? ""}`
    );
    dispatch(getSearchPropertyDetail(data));
    closeSearchBox();
  };

  return (
    <div
      className={
        searchBox
          ? "fixed inset-0 h-full bg-slate-800/10 bg-opacity-75 transition-all duration-700"
          : ""
      }
    >
      <div className="homer_search_section  lg:h-20 px-20">
        <div
          className={`max-w-xl lg:max-w-[90rem] w-full mx-auto search-section lg:grid ${searchBox ? "block" : "hidden"}`}
        >
          <div className="flex lg:hidden justify-between items-center py-4 px-3 border-b">
            <h2 className="text-2xl font-semibold">Search Property</h2>
            <button type="button" onClick={closeSearchBox}>
              <SvgIcon iconName="close" className="size-8" />
            </button>
          </div>

          <FormikWrapper
            initialValues={initialValues}
            onSubmit={handleSearchProperty}
            buttonProps={{
              isHide: true,
            }}
          >
            <SearchForm stateList={stateList} />
          </FormikWrapper>
        </div>
      </div>
    </div>
  );
};

export default SearchSection;
